import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import SelectDateRange from "../components/common/selectDateRange";
import Select from "../components/common/select";
import http from "../services/http";
import UserContext from "../context/userContext";

const Reports = () => {
  const [user] = useContext(UserContext);

  const [categories, setCategories] = useState([]);
  const [personalReports, setPersonalReports] = useState([]);
  const [sharedReports, setSharedReports] = useState([]);
  const [operations, setOperations] = useState([]);
  const [category, setCategory] = useState("");
  const [report, setReport] = useState("");
  const [operation, setOperation] = useState("");
  const [fromDate, setFromDate] = useState(moment());
  const [toDate, setToDate] = useState(moment());
  const [type, setType] = useState("");

  useEffect(() => {
    document.title = "FTR - Reports";
    return () => {
      document.title = "FTR";
    };
  }, []);

  useEffect(() => {
    async function getCategories() {
      try {
        const { data } = await http.get(`/report-categories`);
        setCategories(data);
      }
      catch {
        //ignore error
      }
    }

    async function getPersonalReports() {
      try {
        const { data } = await http.get(`/reports/Personal`);
        setPersonalReports(data);
      }
      catch {
        //ignore error
      }
    }

    async function getOperations() {
      try {
        const { data } = await http.get(`/operations/active`);
        setOperations(data);
      }
      catch {
        //ignore error
      }
    }

    if (user) {
      getCategories();
      getPersonalReports();
      getOperations();
    }
  }, [user]);

  useEffect(() => {
    async function getSharedReports() {
      try {
        const { data } = await http.get(`/reports/Shared?category=${category}`);
        setSharedReports(data);
      }
      catch {
        //ignore error
      }

    }
    if (category) {
      getSharedReports();
    }
  }, [category]);

  async function handleRunReport(e) {
    e.preventDefault();

    // Validate Inputs
    if (!report) return toast.error("invalid report");

/*     try { */
      let reportName = '';
       if (type === "P") {
        reportName = personalReports.find(x => x.ID === +report).OUTPUT_FILE_NAME;
      }
      else {
        reportName = sharedReports.find(x => x.ID === +report).OUTPUT_FILE_NAME;
      }

      reportName = (reportName === null || reportName === undefined) ? 'Unnamed Report' : reportName.slice(0, -5);

      const apiFDate = moment(fromDate).format("YYYY-MM-DD");
      const apiTDate = moment(toDate).format("YYYY-MM-DD");
const suggestedName = `${reportName} ${apiFDate} ${apiTDate}.xlsx`;

      const options = {
        suggestedName: suggestedName,
        types: [{
          description: "Excel file",
          accept: {'text/plain': ['.xlsx']}
        }]
      };

      const newHandle = await window.showSaveFilePicker(options);

      const { data } = await http.get(`/report/${user.SITE}/${report}/${apiFDate}/${apiTDate}/${ operation
        ? operation
        : "NONE" }`,
        {
          responseType: 'arraybuffer',
          responseEncoding: 'binary'
        }
      );

      const writableStream = await newHandle.createWritable();
      await writableStream.write(data);
      await writableStream.close();

/*     } catch (ex) {
      if (ex.response) {
        toast.error(ex.response.data);
      }
    } */
  }

  function handleFromChange({ currentTarget: input }) {
    setFromDate(moment(input.value));
  }

  function handleToChange({ currentTarget: input }) {
    setToDate(moment(input.value));
  }

  return (
    <div className="col mt-4">
      <form className="container">
        <div className="row">
          <div className="col">
            <Select
              name="personal-report"
              label="Personal Report"
              placeholder="Report"
              value={type === "P" ? report : ""}
              options={[{ ID: "", REPORT_NAME: "" }, ...personalReports]}
              listKey="ID"
              listName="REPORT_NAME"
              onChange={(e) => {
                setType("P");
                setReport(e.currentTarget.value);
              }}
            />
          </div>
          <div className="col">
            <Select
              name="category"
              label="Shared Category"
              placeholder="Category"
              value={category}
              options={categories}
              listKey="ID"
              listName="NAME"
              onChange={(e) => {
                setCategory(e.currentTarget.value);
              }}
            />
            <Select
              name="shared-report"
              label="Shared Report"
              placeholder="Report"
              value={type === "S" ? report : ""}
              options={[{ ID: "", REPORT_NAME: "" }, ...sharedReports]}
              listKey="ID"
              listName="REPORT_NAME"
              onChange={(e) => {
                setType("S");
                setReport(e.currentTarget.value);
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Select
              name="operation"
              label="Operation"
              placeholder="Operation"
              value={operation}
              options={operations}
              onChange={(e) => setOperation(e.currentTarget.value)}
              listKey="CODE"
              listName="COMMENTS"
            />
          </div>
          <div className="col">
            <SelectDateRange
              label="Date Range"
              // labelFrom="From"
              // labelTo="To"
              value={fromDate.format("YYYY-MM-DD")}
              value2={toDate.format("YYYY-MM-DD")}
              onFromChange={handleFromChange}
              onToChange={handleToChange}
            />

          </div>
        </div>
        <div className="row">
          <div className="col">
            <button className="btn btn-primary" onClick={handleRunReport}>
              Run Report
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Reports;
